module.exports = __webpack_public_path__ + "static/media/backwards.cbdb4292.svg";